import * as React from 'react';
/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the [[useSelectSingle]] hook.
 */
export var SelectSingleContext = React.createContext(undefined);
//# sourceMappingURL=SelectSingleContext.js.map